import { render, staticRenderFns } from "./UserOrgControl.vue?vue&type=template&id=2bf27b5a&"
import script from "./UserOrgControl.vue?vue&type=script&lang=js&"
export * from "./UserOrgControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports